import {ApolloClient, ApolloLink, from, createHttpLink, InMemoryCache} from "@apollo/client";
import {getStoredLanguage} from "./common.slice";
import { onError } from "@apollo/client/link/error";
import faro from "./faro.service";

const errorLink = onError(({ graphQLErrors, networkError, operation, }) => {
  const { headers } = operation.getContext();
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      const error = new Error(`Message: ${message}, Location: ${locations?.toString()}, Path: ${path}, Headers: ${JSON.stringify(headers)}, Variables: ${JSON.stringify(operation.variables)}`);
      error.name = 'GraphQL Error';
      console.error(error);
      faro?.api?.pushError(error);
    });
  }

  if (networkError) {
    const error = new Error(`${networkError.message}, Headers: ${JSON.stringify(headers)}, Variables: ${JSON.stringify(operation.variables)}`);
    error.name = 'Network Error';
    error.stack = networkError.stack;
    console.error(error);
    faro?.api?.pushError(error);
  }
});

export interface ApolloServiceOptions {
    uri: string;
}

export class ApiService {
    static client: ApolloClient<any>;

    static init(options: ApolloServiceOptions) {
        const uri = (options.uri.indexOf('http://') === 0 || options.uri.indexOf('https://') === 0) ? options.uri : `${document.location.origin}${options.uri}`;

        const httpLink = createHttpLink({
            uri,
            credentials:"include"//"omit"  //TODO uncomment
        });

        const setLocaleLink = new ApolloLink((operation, forward) => {
            operation.setContext(({ headers = {} }) => ({
                headers: {
                    ...headers,
                    "Accept-Language": getStoredLanguage(),
                }
            }));
            return forward(operation);
        });

        const link = from([
          setLocaleLink,
          errorLink,
          httpLink
        ]);
        
        this.client = new ApolloClient({
            link,
            cache: new InMemoryCache(),
            defaultOptions: {
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
            }
        });
    }

    static getClient(): ApolloClient<any> {
        return this.client;
    }
}

